<template>
  <div>
    <div style="font-size: 18px;padding-bottom: 20px;text-align: center;">
      {{this.salesmanId ? '编辑商务人员' : '新增商务人员'}}
    </div>
    <a-form-model :label-col="{ span: 7 }" :wrapper-col="{ span: 16 }" :colon="false" :model="form.data"
                  :rules="formRules" ref="salemanForm">
      <a-form-model-item label="姓名" prop="name">
        <a-input v-model="form.data.name" auto-complete="off" placeholder="请输入姓名"></a-input>
      </a-form-model-item>
      <a-form-model-item label="电话号码" prop="telephone">
        <a-input v-model="form.data.telephone" auto-complete="off" placeholder="请输入电话号码"></a-input>
      </a-form-model-item>
      <a-form-model-item label="权限" prop="isAdmin">
        <a-select v-model="form.data.isAdmin" placeholder="请选择权限">
          <a-select-option
            v-for="item in data"
            :key="item.id"
            :label="item.name"
            :value="item.id">
            {{ item.name }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="邮箱" prop="email">
        <a-input v-model="form.data.email" auto-complete="off" placeholder="请输入邮箱"></a-input>
      </a-form-model-item>
      <a-form-model-item label="公司" prop="company">
        <a-input v-model="form.data.company" auto-complete="off" placeholder="请输入公司"></a-input>
      </a-form-model-item>
      <a-form-model-item label="备注" prop="remark">
        <a-input v-model="form.data.remarks" auto-complete="off" placeholder="请输入备注"></a-input>
      </a-form-model-item>
    </a-form-model>
    <!--    <div slot="footer" class="dialog-footer" style="text-align: center;">-->
    <!--      <a-button type="primary" @click="cancel()"-->
    <!--                 class="project-dialog-button">取消-->
    <!--      </a-button>-->
    <!--      <a-button type="primary" @click="save()"-->
    <!--                 class="project-dialog-button">保存-->
    <!--      </a-button>-->
    <!--    </div>-->
  </div>
</template>

<script>
import {findSalesman, updateSalesman, saveSalesman} from '../../../api/salesman';
import {email, phone} from '../../../utils/validateForm';

async function getSalesman() {
    if (this.form.data.id) {
        const salesman = await findSalesman(this.form.data.id);
        console.log(salesman.data.salesmen)
        if (salesman.code === 1200) {
            this.$set(this.form.data, 'name', salesman.data.salesmen.name);
            this.$set(this.form.data, 'telephone', salesman.data.salesmen.telephone);
            this.$set(this.form.data, 'email', salesman.data.salesmen.email);
            this.$set(this.form.data, 'company', salesman.data.salesmen.company);
            if (salesman.data.salesmen.isCustomer === 1) {
                this.$set(this.form.data, 'isAdmin', 2);
            }
            this.$set(this.form.data, 'isAdmin', salesman.data.salesmen.isAdmin);
        }
    } else {
        this.form.data = {};
        this.form.data.isAdmin = 0;
    }
}

function save() {
    this.$refs.salemanForm.validate(async (valid) => {
        if (valid) {
            if (this.form.data.id) {
                const resultUpdate = await updateSalesman(this.form.data);
                const messagesUpdate = '更新成功';
                if (resultUpdate.code === 1200) {
                    this.$message.success('更新成功');
                    this.getList();
                    this.form.data = {};
                } else {
                    this.$message.error('更新失败');
                }
            } else {
                const resultAdd = await saveSalesman(this.form.data);
                const messagesAdd = '添加成功';
                if (resultAdd.code === 1200) {
                    this.$message.success(messagesAdd);
                    this.getList();
                    this.form.data = {};
                } else {
                    this.$message.error('添加失败');
                }
            }
        } else {
            this.$message.error("数据格式不正确")
        }
    });
    // this.getList()
}

function cancel() {
    this.$refs.salemanForm.resetFields();
}

const emailFormat = (rule, value, callback) => {
    if (!value) {
        return callback(new Error('请输入邮箱'));
    }
    if (email(value)) {
        callback();
    } else {
        return callback(new Error('邮箱输入格式不正确'));
    }
};

// 判断电话号格式
const phoneFormat = (rule, value, callback) => {
    if (!value) {
        return callback(new Error('请输入电话号码'));
    }
    if (phone(value)) {
        callback();
    } else {
        return callback(new Error('电话号码输入格式不正确'));
    }
};

export default {
    name: 'UserEdit',
    props: {
        salesmanId: String,
        onSaveHandler: Function,
        onCancelHandler: Function,
        getList: Function
    },
    data() {
        return {
            formLabelWidth: '90px',
            form: {
                data: {
                    id: '',
                    name: '',
                    telephone: '',
                    isAdmin: 0,
                    email: '',
                    company: '',
                    remarks: ''
                },
            },
            data: [{
                id: 0,
                name: '商务人员'
            }, {
                id: 1,
                name: '管理人员'
            }, {
                id: 2,
                name: '客户'
            }],
            formRules: {
                name: [
                    { required: true, message: '请输入姓名', trigger: 'blur' },
                ],
                telephone: [
                    { required: true, validator: phoneFormat, trigger: 'blur' },
                ],
                email: [
                    { required: false },
                ],
                company: [
                    { required: true, message: '请输入公司', trigger: 'blur' }
                ],
                remark: [
                    { required: false }
                ]
            },
        };
    },
    watch: {
        salesmanId(val) {
            this.form.data = {};
            this.form.data.id = val;
            this.getSalesman();
        },
    },
    created() {
        this.form.data.id = this.salesmanId;
        console.log(this.salesmanId)
        if (this.salesmanId !== '') {
            this.getSalesman();
        }
    },
    methods: {
        save,
        cancel,
        getSalesman,
    },
};
</script>

<style scoped>

</style>
